const nullRemover = (text: string) => text?.replace(/\s/g, '');

export default nullRemover;
